export default {
  registerForm: {
    title: 'Sign Up',
    registerSuccess: 'Sign Up Successfully',
    verification: {
      title: 'Please enter the verification code sent to {email} to sign up.',
      send: 'Verification Code Sent',
      noReceived: 'Didn’t get the code?',
      resend: 'Resend Code',
    },
    existAccount: 'Already have an account?',
    backLogin: 'Back to Login',
    previousStep: 'Back',
    validatePassword: 'Your passwords do not match.',
    email: {
      placeholder: 'Please enter your email',
      registered: 'The email has already been taken, please log in.',
    },
    is_agree: {
      legal_agreement: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      connectText: 'and',
      checkPrompt: 'Please check the confidentiality agreement.',
    },
    contact: {
      name: 'Contact Name',
      pleaseInput: 'Please enter contact name',
      cell: 'Phone Number',
    },
    country: {
      placeholder: 'Country or Region',
    },
    organization: {
      placeholder: 'Company',
    },
    representative: {
      placeholder: 'Referrer Name',
    },
    username: {
      placeholder: 'Username',
      pleaseInput: 'Please enter your username',
      complianceCheck:
        'Must start with a letter, only can contain numbers, letters, underscore, 3-32 characters.',
      alreadyExist: 'The name has already been taken.',
    },
    password: {
      placeholder: 'Password',
      pleaseInput: 'Please enter a password',
      specialCharacterCheck: 'Password cannot contain special characters',
      characterCheck:
        '8 to 20 characters long, combination of digit, capital and lowercase letter.',
    },
    repassword: {
      placeholder: 'Confirm Password',
      pleaseInput: 'Please enter the confirmation password',
    },
    submitBtn: {
      register: 'Sign Up({currentForm}/4)',
      nextStep: 'Next({currentForm}/4)',
    },
  },
  registerSuccessRouteToPc:
    'For a better product experience, please visit the link below on a PC to log in.',
}
